import { gql } from '@apollo/client';
import { counterPartyModel } from '../../../model';
import { basePagingResult } from '../base';

export const counterPartiesFragment = `  
    id,
    name,
    reference,
    counterPartyTypes {
      id,
      name
    },
    businessUnitId,
    businessUnit {
      id,
      name
    }
    bargeScope
`;

export const directoryFragment = `
    maritimeDirectories {
      id
      contactId
      contact {
        id
        name
      }
      ports {
        id
        portId
        port {
          id
          name
          reference
        }
        isActive
      }
    }
`;

export const getCounterPartiesFragment = `
  items {
    ${counterPartiesFragment}
  },
  totalCount
`;

export const getCounterPartiesWithDirectoryFragment = `
  items {
    ${counterPartiesFragment}
    ${directoryFragment}
  },
  totalCount
`;

export type GetCounterPartiesOutput = {
  counterParties?: basePagingResult<counterPartyModel>;
};

export const GET_COUNTER_PARTIES = gql`
  query getCounterParties($name: String, $take: Int!, $skip: Int!, $where: CounterPartyFilterInput) {
    counterParties(name: $name, take: $take, skip: $skip, where: $where) {
      ${getCounterPartiesFragment}
    }
  }
`;

export const GET_COUNTER_PARTIES_WITH_PORT = gql`
  query getCounterParties($name: String, $take: Int!, $skip: Int!, $where: CounterPartyFilterInput) {
    counterParties(name: $name, take: $take, skip: $skip, where: $where) {
      ${getCounterPartiesWithDirectoryFragment}
    }
  }
`;
